import { render, staticRenderFns } from "./ResellerMoreDropdown.vue?vue&type=template&id=60d42e80"
import script from "./ResellerMoreDropdown.vue?vue&type=script&lang=js"
export * from "./ResellerMoreDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports